import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ChangeDetectionStrategy
} from '@angular/core';
import { PreferenceAudit, PreferenceSkeleton } from '../../+models/person-profile-audit.model';

@Component({
  selector: 'sd-portal-person-profile-preference-audit-list',
  templateUrl: './person-profile-preference-audit-list.component.html',
  styleUrls: ['./person-profile-preference-audit-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PersonProfilePreferenceAuditListComponent implements OnInit {
  @Input() preference: PreferenceSkeleton;
  @Input() loading: boolean;
  @Input() preferenceAudits: PreferenceAudit[];

  @Output() loadPreferenceAudits = new EventEmitter<number>();
  @Output() nextPage = new EventEmitter<number>();

  constructor() {}

  ngOnInit() {}

  loadData() {
    this.loadPreferenceAudits.emit(this.preference.preferenceId);
  }

  onNextPage() {
    this.nextPage.emit(this.preference.preferenceId);
  }
}
